var Mustache = require("mustache")

export default class IcmaDoc {
    constructor() {
        //eslint-disable-next-line

        this.json = `{"pageSize":"LETTER","pageMargins":45,"content":[{"image":"{{{logo}}}","width":120,"alignment":"center","margin":[0,0,0,20]},{"text":"Driver Expectations","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,16]},{"text":"The following expectations apply to all Elite Logistics, Inc. Independent Contractors.","bold":true},{"ol":[{"text":"The Independent Contractor should have a smartphone that has the ability to function throughout the entire assignment.  Independent Contractor should download and properly use all functions of the Elite Extra App. When Independent Contractor arrives at the assigned location, they should exchange phone numbers with the dispatcher before departing on the first run.  If the dispatcher calls, the Independent Contractor should answer their phone when it is safe to do so.  The dispatcher will communicate to the Independent Contractor when they are clear to leave.","style":"listitem"},{"text":"Elite Logistics offers contracts daily from 6 a.m. to 7 a.m. via phone and Independent Contractor should answer their phone in order to accept a contract for that day.","style":"listitem"},{"text":"Independent Contractor should report to contracted location on time, dressed appropriately per the customer, and contract for the entire length of the daily contract.  Independent Contractor should have proper equipment to satisfy the customer's needs, including a full tank of gas and equipment to secure the load.","style":"listitem"},{"text":"The Independent Contractor is responsible for the product they are delivering. Part numbers and quantities should be verified before leaving the location and any discrepancies should be reported to dispatcher. All invoices have a ¨BILL TO¨ and a ¨SHIP TO¨ address printed on them. Unless dispatcher says otherwise, product should be delivered to the ¨SHIP TO¨ address.  Any products that are lost or damaged can be charged back to Independent Contractor at Elite's cost.","style":"listitem"},{"text":"All COD's are the Independent Contractor's responsibility until signed off by the dispatcher or other assigned employee at the contracted location. All paperwork and COD's should be turned in after every run or the next business morning. If a customer has returns they want to deduct from a COD invoice, Independent Contractor should call dispatcher for approval. If the customer states that they have a credit card on file, the Independent Contractor should keep accurate records of COD's and have them readily available for verification purposes. Any COD's and paperwork that are not turned in and signed off by the dispatcher can be billed back to the Independent Contractor.","style":"listitem"},{"text":"The Independent Contractor should pick up all returns from the customer. The returns should have proper paperwork, either a copy of the original invoice or a filled out return form. If for any reason the Independent Contractor cannot pick up the returns, the Independent Contractor should notify the dispatcher immediately. Any returns that are lost or not turned into the contacted location with proper paperwork can be billed to the Independent Contractor.","style":"listitem"},{"text":"The Independent Contractor will be required to set up their own LLC and provide verification to Elite Logistics.","style":"listitem"},{"ul":[{"text":
        ["Trade names can be obtained at ",{"text":"http://www.sos.state.co.us/biz/Welcome.do","style":"link"}]},{"text":["EIN's can be obtained at ",{"text":"https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers","style":"link"}]}],"margin":[10,0,0,15]}],"margin":[0,10,0,20]},{"columns":[{"width":120,"text":"Dated:","bold":true,"margin":[0,0,0,25]},{"width":120,"text":"{{{date}}}"}]},{"columns":[{"width":120,"text":"Contractor Name:","bold":true,"margin":[0,0,0,25]},{"width":120,"text":"{{{userName}}}"}]},{"text":"Signature:","bold":true},{"image":"{{{signature}}}","fit":[90,250],"margin":[130,-20,0,0]},{"canvas":[{"type":"line","x1":120,"y1":0,"x2":280,"y2":0,"lineWidth":1}]}],"defaultStyle":{"fontSize":10,"bold":false},"styles":{"listitem":{"margin":[0,0,0,9]},"label":{"bold":true},"link":{"color":"#333","fontSize":8}}}`

        /*
        this.formatted = `
{
  "pageSize": "LETTER",
  "pageMargins": 45,
  "content": [
    {
      "image": "{{{logo}}}",
      "width": 120,
      "alignment": "center",
      "margin": [
        0,
        0,
        0,
        20
      ]
    },
    {
      "text": "Driver Expectations",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        16
      ]
    },
    {
      "text": "The following expectations apply to all Elite Logistics, Inc. Independent Contractors.",
      "bold": true
    },
    {
      "ol": [
        {
          "text": "The Independent Contractor should have a smartphone that has the ability to function throughout the entire assignment.  Independent Contractor should download and properly use all functions of the Elite Extra App. When Independent Contractor arrives at the assigned location, they should exchange phone numbers with the dispatcher before departing on the first run.  If the dispatcher calls, the Independent Contractor should answer their phone when it is safe to do so.  The dispatcher will communicate to the Independent Contractor when they are clear to leave.",
          "style": "listitem"
        },
        {
          "text": "Elite Logistics offers contracts daily from 6 a.m. to 7 a.m. via phone and Independent Contractor should answer their phone in order to accept a contract for that day.",
          "style": "listitem"
        },
        {
          "text": "Independent Contractor should report to contracted location on time, dressed appropriately per the customer, and contract for the entire length of the daily contract.  Independent Contractor should have proper equipment to satisfy the customer's needs, including a full tank of gas and equipment to secure the load.",
          "style": "listitem"
        },
        {
          "text": "The Independent Contractor is responsible for the product they are delivering. Part numbers and quantities should be verified before leaving the location and any discrepancies should be reported to dispatcher. All invoices have a ¨BILL TO¨ and a ¨SHIP TO¨ address printed on them. Unless dispatcher says otherwise, product should be delivered to the ¨SHIP TO¨ address.  Any products that are lost or damaged can be charged back to Independent Contractor at Elite's cost.",
          "style": "listitem"
        },
        {
          "text": "All COD's are the Independent Contractor's responsibility until signed off by the dispatcher or other assigned employee at the contracted location. All paperwork and COD's should be turned in after every run or the next business morning. If a customer has returns they want to deduct from a COD invoice, Independent Contractor should call dispatcher for approval. If the customer states that they have a credit card on file, the Independent Contractor should keep accurate records of COD's and have them readily available for verification purposes. Any COD's and paperwork that are not turned in and signed off by the dispatcher can be billed back to the Independent Contractor.",
          "style": "listitem"
        },
        {
          "text": "The Independent Contractor should pick up all returns from the customer. The returns should have proper paperwork, either a copy of the original invoice or a filled out return form. If for any reason the Independent Contractor cannot pick up the returns, the Independent Contractor should notify the dispatcher immediately. Any returns that are lost or not turned into the contacted location with proper paperwork can be billed to the Independent Contractor.",
          "style": "listitem"
        },
        {
          "text": "The Independent Contractor will be required to set up their own LLC and provide verification to Elite Logistics.",
          "style": "listitem"
        },
        {
          "ul": [
            {
              "text": [
                "Trade names can be obtained at ",
                {
                  "text": "http://www.sos.state.co.us/biz/Welcome.do",
                  "style": "link"
                }
              ]
            },
            {
              "text": [
                "EIN's can be obtained at ",
                {
                  "text": "https://www.irs.gov/businesses/small-businesses-self-employed/employer-id-numbers",
                  "style": "link"
                }
              ]
            }
          ],
          "margin": [
            10,
            0,
            0,
            15
          ]
        }
      ],
      "margin": [
        0,
        10,
        0,
        20
      ]
    },
    {
      "columns": [
        {
          "width": 120,
          "text": "Dated:",
          "bold": true,
          "margin": [
            0,
            0,
            0,
            25
          ]
        },
        {
          "width": 120,
          "text": "{{{date}}}"
        }
      ]
    },
    {
      "columns": [
        {
          "width": 120,
          "text": "Contractor Name:",
          "bold": true,
          "margin": [
            0,
            0,
            0,
            25
          ]
        },
        {
          "width": 120,
          "text": "{{{userName}}}"
        }
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "image": "{{{signature}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        130,
        -20,
        0,
        0
      ]
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 120,
          "y1": 0,
          "x2": 280,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    }
  ],
  "defaultStyle": {
    "fontSize": 10,
    "bold": false
  },
  "styles": {
    "listitem": {
      "margin": [
        0,
        0,
        0,
        9
      ]
    },
    "label": {
      "bold": true
    },
    "link": {
      "color": "#333",
      "fontSize": 8
    }
  }
}
          `
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
